module.exports = __webpack_public_path__ + "static/canadian_bank_note_company_logo-1ded94b97328fca8be6abf8091f338bd.png";